import JSZip from "jszip";
import {
  CSV_EXTENSION,
  EXCEL_EXTENSION,
  IMAGE_EXTENSIONS,
  PDF_EXTENSION,
} from "../../../../utils/parseFile";
import { ZippedFiles } from "./readGerberZip";

const FILE_MAPPING_NAME = "file-mapping.json";
const EXTREP_EXTENSION = ".EXTREP";

export async function identifyFileTypesInGerberZip(
  file: Blob,
): Promise<ZippedFiles> {
  const zip = await JSZip.loadAsync(file);
  const allFiles = (
    await Promise.all(
      zip
        .filter((path) => {
          return !path.endsWith("/") && !path.startsWith("__MACOSX");
        })
        .map(async (zippedFile) => {
          if (
            zippedFile.name.endsWith(EXCEL_EXTENSION) ||
            zippedFile.name.endsWith(CSV_EXTENSION)
          ) {
            const fileContent = await zippedFile?.async("blob");
            return { path: zippedFile.name, content: fileContent };
          }
          const fileContent = await zippedFile?.async("string");
          return { path: zippedFile.name, content: fileContent };
        }),
    )
  ).sort((a, b) => {
    return a.path > b.path ? 1 : b.path > a.path ? -1 : 0;
  });

  const gerberFiles = allFiles.filter(({ path, content }) => {
    if (
      content !== undefined &&
      !path.endsWith(EXCEL_EXTENSION) &&
      !path.endsWith(CSV_EXTENSION) &&
      !path.endsWith(PDF_EXTENSION) &&
      !IMAGE_EXTENSIONS.some((imageExt) => path.endsWith(imageExt))
    ) {
      const trimmedFileContent = (content as string).trimEnd();
      if (trimmedFileContent.endsWith("M02*")) {
        return true;
      }
    }
    return false;
  });
  const excellonFiles = allFiles.filter(({ path, content }) => {
    if (
      content !== undefined &&
      !path.endsWith(EXCEL_EXTENSION) &&
      !path.endsWith(CSV_EXTENSION)
    ) {
      const trimmedFileContent = (content as string).trimEnd();
      if (trimmedFileContent.endsWith("M30")) {
        return true;
      }
    }
    return false;
  });
  const drillFiles = [...gerberFiles, ...excellonFiles];

  const fileMappingFile = allFiles.find(({ path }) => {
    return path == FILE_MAPPING_NAME;
  });

  const extrepFile = allFiles.find(({ path }) => {
    return path.endsWith(EXTREP_EXTENSION);
  });
  const bomOrPNPFiles = allFiles.filter(
    ({ path }) =>
      path.endsWith(EXCEL_EXTENSION) || path.endsWith(CSV_EXTENSION),
  );
  const additionalFiles = allFiles.filter(
    ({ path }) =>
      path.toLowerCase().endsWith(EXCEL_EXTENSION) ||
      path.toLowerCase().endsWith(CSV_EXTENSION) ||
      IMAGE_EXTENSIONS.some((imageExt) =>
        path.toLowerCase().endsWith(imageExt),
      ) ||
      path.toLowerCase().endsWith(PDF_EXTENSION),
  );

  return {
    allFiles,
    gerberFiles,
    drillFiles,
    fileMappingFile,
    extrepFile,
    bomOrPNPFiles,
    additionalFiles,
  };
}
